/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Active_State_TagInputs */

const en_active_state_tag = /** @type {(inputs: Active_State_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active`)
};

const ar_active_state_tag = /** @type {(inputs: Active_State_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نشط`)
};

const de_active_state_tag = /** @type {(inputs: Active_State_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiv`)
};

const es_active_state_tag = /** @type {(inputs: Active_State_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activo`)
};

const fr_active_state_tag = /** @type {(inputs: Active_State_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actif`)
};

const it_active_state_tag = /** @type {(inputs: Active_State_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attivo`)
};

const ja_active_state_tag = /** @type {(inputs: Active_State_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクティブ`)
};

const ko_active_state_tag = /** @type {(inputs: Active_State_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`활성화됨`)
};

const pt_br_active_state_tag = /** @type {(inputs: Active_State_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ativado`)
};

const ru_active_state_tag = /** @type {(inputs: Active_State_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Активный`)
};

const th_active_state_tag = /** @type {(inputs: Active_State_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ใช้งานอยู่`)
};

const tr_active_state_tag = /** @type {(inputs: Active_State_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktif`)
};

const zh_cn_active_state_tag = /** @type {(inputs: Active_State_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生效中`)
};

const zh_tw_active_state_tag = /** @type {(inputs: Active_State_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生效中`)
};

/**
* | output |
* | --- |
* | "Active" |
*
* @param {Active_State_TagInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const active_state_tag = /** @type {((inputs?: Active_State_TagInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Active_State_TagInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_active_state_tag(inputs)
	if (locale === "ar") return ar_active_state_tag(inputs)
	if (locale === "de") return de_active_state_tag(inputs)
	if (locale === "es") return es_active_state_tag(inputs)
	if (locale === "fr") return fr_active_state_tag(inputs)
	if (locale === "it") return it_active_state_tag(inputs)
	if (locale === "ja") return ja_active_state_tag(inputs)
	if (locale === "ko") return ko_active_state_tag(inputs)
	if (locale === "pt_br") return pt_br_active_state_tag(inputs)
	if (locale === "ru") return ru_active_state_tag(inputs)
	if (locale === "th") return th_active_state_tag(inputs)
	if (locale === "tr") return tr_active_state_tag(inputs)
	if (locale === "zh_cn") return zh_cn_active_state_tag(inputs)
	return zh_tw_active_state_tag(inputs)
});